import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Utils from '../../helpers/Utils';
import { DataEvents, DataCategories, DataActions } from '../../../types/enum';
import { getQuote } from '../../../features/quote/QuoteSlice';

function StickyFooter() {
  const [isShowing, setIsShowing] = useState(true);
  const quoteData = useSelector(getQuote);
  const { innerStep, step: outerStep } = quoteData.step;

  return (
    <footer className={`user-footer mt-auto py-3 w-100 ${isShowing ? '' : 'd-none'}`}>
      <div className="container">
        <div className="row">
          <div className="d-flex">
            <h5 className="user-footer__heading align-self-center">Been here before?</h5>
          </div>
          <div>
            <p>
              Go to your account to start a new quote or see previous quotes and policy documents.
            </p>
          </div>
          <div className="ctas">
            <div className="d-flex justify-content-md-end justify-content-between">
              <a
                href="/login.html"
                className="user-footer__btn user-footer__btn--login btn btn-tel ms-md-4 px-5 btn--green align-self-end py-3 px-4"
                onClick={() => Utils.sendDataLayerEvent({
                  event:
                    DataEvents[DataEvents.analyticsEvent],
                  eventCategory:
                    DataCategories[DataCategories['Quote Journey']],
                  eventAction:
                    DataActions[DataActions['Go to my account']],
                  stepNumber: outerStep + 1,
                  stepName: quoteData.steps[(outerStep)].steps[innerStep].title,
                })}
              >
                Go to my account
              </a>
              <a
                href="/recover_password.html"
                className="user-footer__btn user-footer__btn--retrieve btn btn-tel align-self-end ms-3 py-3 px-4"
                onClick={() => Utils.sendDataLayerEvent({
                  event:
                    DataEvents[DataEvents.analyticsEvent],
                  eventCategory:
                    DataCategories[DataCategories['Quote Journey']],
                  eventAction:
                    DataActions[DataActions['Retrieve password']],
                  stepNumber: outerStep + 1,
                  stepName: quoteData.steps[(outerStep)].steps[innerStep].title,
                })}
              >
                Retrieve password
              </a>
              <a
                href="#close"
                className="user-footer__btn user-footer__btn--close btn btn-outline-light btn-tel align-self-end ms-3 py-3 px-4"
                onClick={(e) => {
                  e.preventDefault();
                  Utils.sendDataLayerEvent({
                    event:
                      DataEvents[DataEvents.analyticsEvent],
                    eventCategory:
                      DataCategories[DataCategories['Quote Journey']],
                    eventAction:
                      DataActions[DataActions['Close tray']],
                    stepNumber: outerStep + 1,
                    stepName: quoteData.steps[(outerStep)].steps[innerStep].title,
                  });
                  setIsShowing(false);
                }}
              >
                X
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default StickyFooter;
